<template>
  <button type="button" class="btn btn-brand" :disabled="loading">
    <div class="spinner-border text-sm" v-if="loading" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <base-icon :icon_name="icon" v-if="(icon.length > 0) & !loading" />
    {{ $t(title) }}
  </button>
</template>
<script>
export default {
  name: "BtnLoading",
  props: {
    loading: Boolean,
    title: String,
    icon: String,
    disabled: Boolean,
  },
};
</script>